window.dataLayer = window.dataLayer || [];

export default function gtag(token) {
  window.dataLayer.push(arguments);
}

gtag('js', new Date());
gtag('config', '<%GA_TOKEN%>', {send_page_view: false});
